var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFEE2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0805 23.212C12.6245 22.78 12.8725 22.58 12.8245 22.612C14.3925 21.316 15.6245 20.252 16.5205 19.42C17.4325 18.588 18.2005 17.716 18.8245 16.804C19.4485 15.892 19.7605 15.004 19.7605 14.14C19.7605 13.484 19.6085 12.972 19.3045 12.604C19.0005 12.236 18.5445 12.052 17.9365 12.052C17.3285 12.052 16.8485 12.284 16.4965 12.748C16.1605 13.196 15.9925 13.836 15.9925 14.668H12.0325C12.0645 13.308 12.3525 12.172 12.8965 11.26C13.4565 10.348 14.1845 9.676 15.0805 9.244C15.9925 8.812 17.0005 8.596 18.1045 8.596C20.0085 8.596 21.4405 9.084 22.4005 10.06C23.3765 11.036 23.8645 12.308 23.8645 13.876C23.8645 15.588 23.2805 17.18 22.1125 18.652C20.9445 20.108 19.4565 21.532 17.6485 22.924H24.1285V26.26H12.0805V23.212Z",
    fill: "#EB433D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img_2.44bb4e701e01e3dffe750b311bc5267b.svg";
export { ForwardRef as ReactComponent };